import { defineNuxtPlugin } from 'nuxt/app'
import { App } from 'vue'
import type { DevToolsHook, VueAppInstance, DevToolsHooks } from '@vue/devtools-kit'
declare global {
  interface Window {
    __VUE_DEVTOOLS_GLOBAL_HOOK__?: DevToolsHook
  }
}

export const MONITOR_EVENTS: boolean = false

export default defineNuxtPlugin((nuxtApp) => {
  if (import.meta.dev) {
    nuxtApp.hook('vue:error', (err) => {
      console.log('---------vue:error---------')
      console.log(err)
    })

    window.__VUE_DEVTOOLS_GLOBAL_HOOK__?.on(
      <DevToolsHooks>'component:emit',
      (_: App, instance: VueAppInstance, event: string, params: never[]) => {
        if (MONITOR_EVENTS) {
          console.log(
            `%c ${instance.type.name}: %c${event}`,
            'font-weight: bold;',
            'color: #d19a02; font-weight: bold;',
          )
          console.log(...params)
        }
      },
    )
  }
})
